import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../composants/Button/Button';
import { ReactComponent as LogoIcon } from "../../assets/logo/logo-centralis-gris.svg";
import './ForgotPassword.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        setSuccess(data.message || "Un email de réinitialisation a été envoyé si l'adresse existe.");
      } else {
        setError(data.message || "Une erreur est survenue.");
      }
    } catch (err) {
      setError("Une erreur est survenue.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <Link to="/" className="forgot-password-back-home">← Retour à l&apos;accueil</Link>
      <div className="forgot-password-card">
        <div className="logo-container">
          <LogoIcon className="logo" />
        </div>
        <h1>Mot de passe oublié</h1>
        <p className="forgot-password-subtitle">Entrez votre adresse email pour recevoir un lien de réinitialisation.</p>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="exemple@email.com"
              required
            />
          </div>
          <div className="form-actions">
            <Button
              type="submit"
              variant="primary"
              value={isLoading ? "Envoi en cours..." : "Envoyer"}
              size="medium"
              disabled={isLoading}
            />
          </div>
        </form>
        <div className="forgot-password-footer">
          <Link to="/login" className="forgot-password-back-login">← Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;